<script lang="ts">
	import Robot from '$lib/components/common/Robot.svelte';
	const commonText = 'text-bfGray dark:text-cosmicPurple100';
	const highlightText = 'text-bloomBlueNormal dark:text-bloomBlueNormal';
	import { page } from '$app/stores';
</script>

<div class="h-96 grid mb-28">
	<div class="self-center justify-self-center">
		<div class="flex flex-col">
			<span class="text-9xl {highlightText}">{$page.status}</span>
			<div class="inline text-gray-600 mt-8">{$page.error.message}</div>
			<div class="text-2xl mt-12">
				<div class="inline {commonText}">Oopsie page not found</div>
			</div>
			<Robot />
		</div>
	</div>
</div>
